import { Message } from '@dinosband/bv-messenger-schema'
import { shouldExcludeMessage } from '@dinosband/bv-messenger-client'

export function _isInvalidMessage (message: Message, userId: number, excludeDeleted: boolean | undefined, blockedProfileIds: number[]) {
  if (blockedProfileIds.some((id) => id === message.profileId)) {
    return true
  }
  const props = message.props
  if (props.designatedUserId) {
    if (props.userId !== userId && props.designatedUserId !== userId) {
      return true
    }
  }
  if (!message.deletedAt) {
    return false
  }
  return excludeDeleted || shouldExcludeMessage(message.deleteReason)
}
